;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ArtsController', ArtsController)

  /* @ngInject */
  function ArtsController ($scope, $rootScope, $q, $timeout, $state, ModalService) {
    const getUploadTemplateDialogController = () => $q.when(import('./dialogs/upload-template/upload-template-dialog.controller'))

    $scope.selectedMenuId = 2
    $scope.companyFeatures = {
      artsCustomization: {
        access: true
      }
    }

    const api = {
      getUploadTemplateDialogController,
      _handleCompanyFeatures
    }
    this.getApi = () => api

    $timeout(function () {
      $(document).scrollTop(0)
    })

    activate()
    function activate () {
      api._handleCompanyFeatures()
    }

    const deregisterArtsChangeSelectedMenuId = $scope.$on('arts.change-selectedMenuId', (e, id) => {
      $scope.selectedMenuId = id
    })

    $scope.$on('$destroy', () => {
      deregisterArtsChangeSelectedMenuId()
    })

    $scope.handleMenuPress = async function (iMenuId) {
      $scope.selectedMenuId = iMenuId

      switch (iMenuId) {
        case 1:
          $state.go('arts.me', {}, { reload: true })
          break
        case 2:
          $state.go(($rootScope.isUser()) ? 'user.arts' : 'arts.templates', {}, { reload: true })
          break
        case 3:
          $state.go('arts.companyTemplates', {}, { reload: true })
          break
        case 4:
          $state.go('arts.companyApprovals', {}, { reload: true })
          break
      }
    }

    $scope.hasActiveSubmenu = function (menu, selectedMenuId) {
      return menu.items.some(m => m.id === selectedMenuId)
    }

    $scope.openUploadTemplateDialog = function () {
      api.getUploadTemplateDialogController().then(({ UploadTemplateDialogController }) => {
        ModalService.showModal({
          templateId: 'uploadTemplate.html',
          templateUrl: '/arts/dialogs/upload-template/upload-template-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          controller: UploadTemplateDialogController,
          data: {
            isUploadingTemplate: true
          }
        })
      })
    }

    function _handleCompanyFeatures () {
      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
        $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
      })
    }
  }
})()
